import type { FaireProductEntity } from "../../entity_types/product";

export const p_eq9gnyk6j7: FaireProductEntity = {
  token: "p_eq9gnyk6j7",
  type: "product",
  name: "Sandalwood Rose - 7.75 fl oz Room & Linen Spray",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/5f129cab771e3c4df7fc240a9ed0c8b35acd953c924999b003c74393b8322513.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/806c2292c9e764b1c819aa2c931adcd103549e241f8da09a1df5734bc44f03b9.webp",
    "https://cdn.faire.com/fastly/b3009c2d29a51b387d19f7b7019e09fdbfc3fd99d2c15d71f8012f8548c0d172.jpeg",
    "https://cdn.faire.com/fastly/0ece1f65d00e039398bd301e825c7a2b93c12995ec279878db0c664bb02bcdd9.jpeg",
    "https://cdn.faire.com/fastly/dcf251b4db8351b2edd624e8c187b03f6a2d8696d5f8b2412ac397924d4c2344.jpeg",
    "https://cdn.faire.com/fastly/c8204198990372227fbca763174af767f6553facc4394d12aa05d2aec7aa9d35.jpeg",
    "https://cdn.faire.com/fastly/92c380a966cb4b7aa888644ea633272196abffc9515d6589e28c4e7bc1f82fdd.jpeg",
    "https://cdn.faire.com/fastly/bc5a0c814899f777c13d6bdd067084d1a868270b280ceb550a2f0c344844dee1.jpeg",
  ],
  priceDollars: 10,
  description:
    "New York meets Los Angeles. Our take on a unisex floral. Cashmere rose, oud, and sandalwood.\n\nOur Room & Linen Sprays offer an effortless, fine mist with a light fragrance! Meant for daily use on bedsheets, pillows, couches - anywhere that needs a bit of a boost. \n\nFragrance lasts longest when applied directly onto fabrics, especially any with a thicker weave.\n\nEach 7.75 oz amber bottle contains water, phthalate-free premium fragrance oil (body safe), and two cosmetic-grade preservatives meant to maintain quality and prolong shelf-life: phenoxyethanol and caprylyl glycol.\n\nYour customers might also like earthy Teakwood & Tobacco or floral Geranium Moss.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:54.343Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
